module.exports = __webpack_public_path__ + "img/account-cn.31a904e2.png";